import "../styles/Line.scss"

export function Line(props) {
    return(
        <div className={props.className}></div>
    )
}